import { Popover } from '@mui/material';
import { useState } from 'react';
import DifferencesPopover from './DifferencesPopover';
import EastIcon from '@mui/icons-material/East';
import IssuesPopover from './IssuesPopover';
const getNewFieldOrOldFieldOrEmpty = (obj = {}, field) => {
  let value = obj[field];
  if (value === null || value === undefined) {
    value = obj[`${field}Og`];
  }
  if (value === null || value === undefined) {
    value = '';
  }
  return value;
};

const getCellClass = (item, field) => {
  if (item?.type === 'edited' && item?.changedKeys?.includes(field)) return 'edited-cell';
  if (item?.type === 'with-issues' && item?.issues?.some((issue) => issue?.field === field)) return 'with-issues-cell';
  return '';
};

const ArticlesRow = ({ article, index, style, height }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <tr
      style={style}
      className={
        article?.type === 'edited'
          ? 'edited'
          : article?.type === 'created'
          ? 'created'
          : article?.type === 'with-issues' && 'with-issues'
      }
    >
      <td className={getCellClass(article, 'code')}>
        <div>
          {article?.type === 'with-issues' && (
            <IssuesPopover issues={article?.issues} excelRow={article?.excelRow} excelSheet={article?.excelSheet} />
          )}

          {getNewFieldOrOldFieldOrEmpty(article, 'code')}
        </div>
      </td>
      <td
        className={`${getCellClass(article, 'imglink')} ${
          getNewFieldOrOldFieldOrEmpty(article, 'imglink') && 'truncate-link'
        }`}
      >
        <div>
          {article.imgFile || getNewFieldOrOldFieldOrEmpty(article, 'imglink') || article.imgBase64 ? (
            <img
              style={{
                height,
                objectFit: 'contain',
                border: `1px solid ${
                  article?.type === 'edited' && article?.changedKeys?.includes('imglink') ? '#0b991e' : '#3c4145'
                }`,
              }}
              src={
                article.imgFile
                  ? URL.createObjectURL(article.imgFile)
                  : article.imgBase64 || getNewFieldOrOldFieldOrEmpty(article, 'imglink')
              }
              alt="img"
            />
          ) : (
            <>
              <span
                aria-owns={open ? `mouse-over-popover-${index}` : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
              >
                {getNewFieldOrOldFieldOrEmpty(article, 'imglink') || <i>vacio</i>}
              </span>

              {getNewFieldOrOldFieldOrEmpty(article, 'imglink') && (
                <Popover
                  id={`mouse-over-popover-${index}`}
                  sx={{ pointerEvents: 'none' }}
                  open={open}
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  onClose={handlePopoverClose}
                  disableRestoreFocus
                >
                  <img src={getNewFieldOrOldFieldOrEmpty(article, 'imglink')} alt="img" width="130rem" />
                </Popover>
              )}
            </>
          )}
          <DifferencesPopover show={article?.type === 'edited' && article?.changedKeys?.includes('imglink')}>
            <div>
              <span>
                <img
                  style={{
                    height,
                    objectFit: 'contain',
                    border: `1px solid ${article.imgFile ? '#0b991e' : '#3c4145'}`,
                  }}
                  src={article.imglinkOg}
                  alt="img"
                />
              </span>{' '}
              <EastIcon />{' '}
              <span>
                {' '}
                <img
                  style={{
                    height,
                    objectFit: 'contain',
                    border: `1px solid ${article.imgFile ? '#0b991e' : '#3c4145'}`,
                  }}
                  src={article.imgFile ? URL.createObjectURL(article.imgFile) : article.imgBase64 || article.imglink}
                  alt="img"
                />
              </span>
            </div>
          </DifferencesPopover>
        </div>
      </td>
      <td className={getCellClass(article, 'linkEditable')}>
        <div>
          {getNewFieldOrOldFieldOrEmpty(article, 'linkEditable') || <i>vacio</i>}

          <DifferencesPopover show={article?.type === 'edited' && article?.changedKeys?.includes('linkEditable')}>
            <div>
              <span>{article?.linkEditableOg || <i>vacio</i>}</span> <EastIcon /> <span>{article?.linkEditable}</span>
            </div>
          </DifferencesPopover>
        </div>
      </td>
      <td className={getCellClass(article, 'name')}>
        <div>
          {getNewFieldOrOldFieldOrEmpty(article, 'name') || <i>vacio</i>}
          <DifferencesPopover show={article?.type === 'edited' && article?.changedKeys?.includes('name')}>
            <div>
              <span>{article?.nameOg}</span> <EastIcon /> <span>{article?.name}</span>
            </div>
          </DifferencesPopover>
        </div>
      </td>
      <td className={getCellClass(article, 'centerType')}>
        <div>
          {article?.centerType?.join(', ')}
          <DifferencesPopover show={article?.type === 'edited' && article?.changedKeys?.includes('centerType')}>
            <div>
              <span>{article?.centerTypeOg?.join(', ')}</span> <EastIcon />{' '}
              <span>{article?.centerType?.join(', ')}</span>
            </div>
          </DifferencesPopover>
        </div>
      </td>
      <td className={getCellClass(article, 'regional')}>
        <div>{getNewFieldOrOldFieldOrEmpty(article, 'regional') || <i>vacio</i>}</div>
      </td>
      <td className={getCellClass(article, 'isMontaje')}>
        <div>{getNewFieldOrOldFieldOrEmpty(article, 'isMontaje') ? 'SI' : 'NO'}</div>
      </td>
      {/* <td
        className={article?.type === 'edited' && article?.changedKeys?.includes('isDescargable') ? 'edited-cell' : ''}
      >
        <div>{getNewFieldOrOldFieldOrEmpty(article, 'isDescargable') ? 'SI' : 'NO'}</div>
      </td> */}
      <td className={getCellClass(article, 'active')}>
        <div>{getNewFieldOrOldFieldOrEmpty(article, 'active') ? 'SI' : 'NO'}</div>
      </td>
      <td className={getCellClass(article, 'minQuantity')}>
        <div>{getNewFieldOrOldFieldOrEmpty(article, 'minQuantity') || 1}</div>
      </td>
      <td className={getCellClass(article, 'tags')}>
        <div>
          {article?.tags?.join(', ')}

          <DifferencesPopover show={article?.type === 'edited' && article?.changedKeys?.includes('tags')}>
            <div>
              <span>{article?.tagsOg?.join(', ')}</span> <EastIcon /> <span>{article?.tags?.join(', ')}</span>
            </div>
          </DifferencesPopover>
        </div>
      </td>
      {/* <td
        className={`${
          article?.type === 'edited' && article?.changedKeys?.includes('pdfLanguages.castellano') ? 'edited-cell ' : ''
        } ${getNewFieldOrOldFieldOrEmpty(article, 'pdfLanguages.castellano') && 'truncate-link'}`}
      >
        <div>
          {article?.pdfLanguages?.castellano ? (
            <a href={article?.pdfLanguages?.castellano} target="_blank" rel="noreferrer">
              {article?.pdfLanguages?.castellano}
            </a>
          ) : article?.isDescargable === false ? (
            <i>no aplica</i>
          ) : (
            <i>vacio</i>
          )}
        </div>
      </td>
      <td
        className={
          article?.type === 'edited' && article?.changedKeys?.includes('pdfLanguages.País Vasco') ? 'edited-cell' : ''
        }
      >
        <div>
          {article?.pdfLanguages?.['País Vasco'] ||
            (article?.isDescargable === false ? <i>no aplica</i> : <i>vacio</i>)}
        </div>
      </td>
      <td
        className={
          article?.type === 'edited' && article?.changedKeys?.includes('pdfLanguages.Cataluña') ? 'edited-cell' : ''
        }
      >
        <div>
          {article?.pdfLanguages?.Cataluña || (article?.isDescargable === false ? <i>no aplica</i> : <i>vacio</i>)}
        </div>
      </td>
      <td
        className={
          article?.type === 'edited' && article?.changedKeys?.includes('pdfLanguages.Galicia') ? 'edited-cell' : ''
        }
      >
        <div>
          {article?.pdfLanguages?.Galicia || (article?.isDescargable === false ? <i>no aplica</i> : <i>vacio</i>)}
        </div>
      </td> */}
    </tr>
  );
};

export default ArticlesRow;
